import React, { useMemo } from 'react'
import useOfferTags from 'hooks/Offers/useOfferTags'
import ContentTagLabel from 'components/Content/ContentTagLabel'

interface Props {
  offer?: App.AnyOffer
}

/**
 * Component that displays promotion labels based on offer tags.
 * Converts each tag name to a slug format (search-pill-<tag_name>) and renders a ContentTagLabel for each.
 */
function ContentTagLabels({ offer }: Props) {
  const { tags: offerTags } = useOfferTags(offer?.id)

  const tagSlugs = useMemo(() => {
    return offerTags.map(tag => {
      // Convert tag name to slug format: lowercase and replace spaces with hyphens
      const normalizedTagName = tag.name.toLowerCase().replace(/\s+/g, '-')
      return `search-pill-${normalizedTagName}`
    })
  }, [offerTags])

  if (tagSlugs.length === 0) {
    return null
  }

  return (
    <>
      {tagSlugs.map(slug => (
        <ContentTagLabel key={slug} slug={slug} />
      ))}
    </>
  )
}

export default ContentTagLabels
